import React from "react";

function App() {
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1>Installer Zone App</h1>
      <p>Firebase + React is working!</p>
    </div>
  );
}

export default App;

